import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AiFilterChip } from '../AiFilterChip/AiFilterChip';
import { dateRangeHandler } from '../AiFilterChip/chipHandlers';
import { isExactMatch, rangeDateValueLabel } from './DateRangeChip.utils';
const isUnbounded = (predicate)=>predicate.gte == null && predicate.lte == null && predicate.eq == null && predicate.neq == null;
export const dateRangeChipUnit = (param)=>{
    let { field, predicate, testId, label, texts, onChange, biPrefix, tone, autoOpen } = param;
    return {
        key: field,
        node: /*#__PURE__*/ _jsx(AiFilterChip, {
            mode: "radio",
            testId: testId,
            fieldLabel: label,
            items: [
                {
                    value: 'all',
                    label: texts.allTime
                },
                {
                    value: 'range',
                    label: texts.specificRange
                }
            ],
            selected: predicate.gte != null || predicate.lte != null ? 'range' : 'all',
            valueLabel: isUnbounded(predicate) ? texts.all : rangeDateValueLabel(predicate, label),
            editable: !isExactMatch(predicate),
            datePicker: {
                rangeValue: 'range',
                from: predicate.gte,
                to: predicate.lte,
                texts: {
                    from: texts.from,
                    to: texts.to
                }
            },
            onApply: dateRangeHandler(onChange),
            onRemove: ()=>onChange(undefined),
            autoOpen: autoOpen,
            biPrefix: biPrefix,
            tone: tone,
            texts: {
                apply: texts.apply,
                all: texts.all
            }
        })
    };
};
